import React from 'react';
import { Typography } from 'fronton-react';
import { OrderedList, UnorderedList, UnorderedListItem } from './styles';

export const title = 'Часто задаваемые вопросы';
export const faqItems = [
	{
		title: 'Как заказать шторы?',
		content: (
			<Typography size="body_long" variant="s">
				<OrderedList>
					<li>
						Закажите выезд дизайнера на объект, в удобное для вас время. Дизайнер
						сделает все замеры и фото комнат, учтет все ваши пожелания по шторам и
						карнизам, и предложит варианты проектов окна.
					</li>
					<br />
					<li>
						Или сделайте самостоятельно замеры окна или стены, на котором находиться
						окно, а также фото или видео вашей комнаты. Дизайнер учтет все ваши
						пожелания и предложит разные варианты оформления окна.
					</li>
					<br />
					<li>
						Выберите товар на сайте самостоятельно, либо в магазине вместе с Дизайнером
						или Продавцом консультантом. Определитесь с оформлением окна вместе с
						дизайнером. Оплатите услугу пошив штор и товар на кассе магазина или по
						ссылке. Получите готовое изделие в магазине или закажите доставку.
					</li>
					<br />
					<li>
						Если нет возможности посетить наш магазин, то проект окна может быть
						осуществлен дистанционно, по фотографии вашего окна и интерьера. Отправляете
						нам ваши материалы и пожелания, а мы предложим разные варианты оформления
						окна, подберём ткани, карнизы, сделаем визуализацию штор и оформим заказ.
					</li>
				</OrderedList>
			</Typography>
		),
	},
	{
		title: 'Какой срок изготовления штор?',
		content: (
			<Typography size="body_long" variant="s">
				Срок зависит от сложности изготовления. Сложные проекты исполняются от 3 до 14 дней.{' '}
				<br />
				Экспресс пошив (проверяйте доступность услуги в вашем магазине) может быть выполнен
				в тот же день.
			</Typography>
		),
	},
	{
		title: 'Как замерить окно?',
		content: (
			<Typography size="body_long" variant="s">
				Для красивого проекта пошива Вам необходимо знать не только размеры окна, но и
				стены, на которой оно расположено. <br />
				<br />
				Необходимо замерить:
				<br />
				<UnorderedList>
					<UnorderedListItem>Ширину и высоту оконного проема</UnorderedListItem>
					<UnorderedListItem>
						Высоту и вылет подоконника, а также радиатора под ним
					</UnorderedListItem>
					<UnorderedListItem>Ширину от края проема до стен</UnorderedListItem>
					<UnorderedListItem>Высоту от проема до потолка</UnorderedListItem>
				</UnorderedList>
				Если у Вас уже установлен карниз, необходимо знать и его размеры:
				<br />
				<UnorderedList>
					<UnorderedListItem>
						Тип карниза (шинный, деревянный, круглый и т.д.) и количество рядов
					</UnorderedListItem>
					<UnorderedListItem>Высота установки карниза</UnorderedListItem>
					<UnorderedListItem>
						Ширина карниза и расстояние от его края до стен
					</UnorderedListItem>
					<UnorderedListItem>
						Вылет карниза (расстояние от стены до штанги или паза профиля)
					</UnorderedListItem>
				</UnorderedList>
			</Typography>
		),
	},
	{
		title: 'Как подобрать карниз?',
		content: (
			<Typography size="body_long" variant="s">
				Чтобы избежать ошибок, стоит заранее ответить себе на два вопроса.
				<br />
				<br />
				<Typography variant="s" size="body_accent">
					Насколько тяжёлыми будут шторы?
				</Typography>
				<br />
				<UnorderedList>
					<UnorderedListItem>
						Для лёгких вариантов подойдёт любой карниз. Тяжёлые шторы под силу удержать
						только мощным потолочным конструкциям или же настенным карнизам с
						кронштейнами, которые установлены через каждые 1-1,5 м. Какие крепления
						подойдут для карниза?
					</UnorderedListItem>
					<br />
					<UnorderedListItem>
						Стоит тщательно подобрать люверсы, прищепки, петли или крючки. Тип креплений
						должен соответствовать виду штор, цвету и дизайну карниза. Важно, чтобы
						крепления двигались по карнизу легко и свободно.
					</UnorderedListItem>
				</UnorderedList>
				<Typography variant="s" size="body_accent">
					Как расположены отопительные трубы и подоконник?
				</Typography>
				<br />
				<UnorderedList>
					<UnorderedListItem>
						Карниз нужно закрепить так, чтобы шторы свободно свисали, поэтому нужно
						подбирать длину кронштейна или глубину ниши с учетом этого фактора.
					</UnorderedListItem>
				</UnorderedList>
				Кроме самих карнизов вам могут понадобиться различные крючки, зажимы и кольца,
				заглушки, бегунки и стопоры. Чаще всего аксессуары идут в комплекте с карнизом, но
				бывают и исключения, например, это крепление идёт без наконечника, вы можете
				подобрать его отдельно.
				<br />
				Самые распространённые виды карнизов — круглый настенный и шинный потолочный.
				<br />
				<br />
				Потолочные шинные и гибкие карнизы почти незаметны на белом потолке, так что
				подойдут для любого интерьера. Остальные типы креплений нужно подбирать под
				различные стили.
			</Typography>
		),
	},
];
